/**
 * Data object representing the user-submitted questionnaires list item
 * @note This is usually used in the data table as a row. Params don't have default values since this data object is 
 * used to represent data that actually exists.
 */
export class UserSubmittedQuestionnairesListItemDataObject {
	/**
	 * @param {string} id - DB ID of the user submitted questionnaire.
	 * @param {string} firstName - First name that the user submitted in the questionnaire.
	 * @param {string} lastName - Last name that the user submitted in the questionnaire.
	 * @param {Date} dateOfBirth - Date of birth that the user submitted in the questionnaire.
	 * @param {Date} dateOfSubmission - Date of submission that the user submitted in the questionnaire.
	 * @param {?Gender} gender - Gender that the user submitted in the questionnaire.
	 */
	constructor(id, firstName, lastName, dateOfBirth, dateOfSubmission, gender) {
		this.id = id;
		this.firstName = firstName;
		this.lastName = lastName;
		this.dateOfBirth = dateOfBirth;
		this.dateOfSubmission = dateOfSubmission;
		this.gender = gender;
	}
}